import React from 'react';
import EditFooterRotationLogoText from '../EditFooterRotationLogoText';
import { Box } from '@material-ui/core';
import { Button } from 'react-admin';
import EditTimelineRotationLogoText from '../EditTimelineRotationLogoText';

const RenderEditComponent = (props: any) => {
  function renderComponent(type: string, data: any) {
    switch (type) {
      case 'footer-logo-rotation-text': {
        return (
          <EditFooterRotationLogoText
            widget={props.widget}
            onSubmit={props.onSubmit}
            onCancel={props.onCancel}
          />
        );
      }
      case 'timeline-logo-rotation-text': {
        return (
          <EditTimelineRotationLogoText
            widget={props.widget}
            onSubmit={props.onSubmit}
            onCancel={props.onCancel}
          />
        );
      }
      default: {
        return null;
      }
    }
  }

  return <Box>{renderComponent(props.widgetType, props.widgetData)}</Box>;
};

export default RenderEditComponent;
